import { EMPTY_LIST } from '../../../../constants/common'
import { toUserMultiValue } from '../../../User'
import { DocFlowSendingFieldName } from '../DocFlowSending.constants'

export function getDataItems(response) {
  return response.data.items.map(item =>
    toUserMultiValue(item[DocFlowSendingFieldName.Recipient])
  )
}

export function getApiParams(errorId) {
  return {
    filters: { epost_error_code: [errorId] },
    ordering: EMPTY_LIST,
  }
}
